// src/components/profile/profileStyles.js

import { makeStyles } from '@material-ui/core/styles';

export const COLORS = {
  primary: '#5B2EFF',
  secondary: '#FF003C',
  dark: '#101828',
  text: '#2C3550',
  muted: '#667085',
  border: '#E8EAF2',
  background: '#F8F9FC',

  success: '#16A34A',
  successBg: '#EAF8F0',

  purpleBg: '#F3EAFF',
  blueBg: '#EDF4FF',
  greenBg: '#EAF8F0',
  orangeBg: '#FFF3E8',
  redBg: '#FFF1F3',
};

export const useProfileStyles = makeStyles((theme) => { 
  console.log('theme', theme)
  
  return ({
  
  page: {
    background: COLORS.background,
    minHeight: '100vh',
    padding: theme.spacing(3),
  },


  profileGrid: {
    display: 'grid',
    gap: '1rem',
    gridTemplateColumns: '1fr',
  
    /* Tablet: 2 columns */
    '@media (min-width: 600px)': {
      gridTemplateColumns: 'repeat(2, 1fr)',
    },
    
    /* Desktop: 3 columns */
    '@media (min-width: 900px)': {
      gridTemplateColumns: 'repeat(3, 1fr)',
    },
  },
  
  profileHeaderGrid: {
    gridColumnStart: 1,
    gridColumnEnd: -1,
  },  
  
  profileFullRowGrid: {
    marginTop: '1rem',
    gridColumnStart: 1,
    gridColumnEnd: -1, /* Changed from 4 to -1 to dynamically span all columns on mobile/tablet/desktop */
  }, 



  hero: {
    background: 'linear-gradient(100deg, #4B36E5 0%, #9B1B8E 45%, #FF003C 100%)',
    borderRadius: 20,
    padding: theme.spacing(4),
    color: '#fff',
    position: 'relative',
    overflow: 'hidden',
  },

  heroContent: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(3),
    flexWrap: 'wrap',
  },

  heroLeft: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(3),

    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
      alignItems: 'flex-start',
    },
  },

  avatar: {
    width: 160,
    height: 160,
    border: '5px solid #fff',
    boxShadow: '0 10px 30px rgba(0,0,0,0.2)',
  },

  heroTitle: {
    fontWeight: 800,
    lineHeight: 1.2,
  },

  heroSubTitle: {
    fontWeight: 600,
    marginTop: theme.spacing(1),
  },

  heroMeta: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: theme.spacing(2),
    marginTop: theme.spacing(2),
    fontWeight: 600,
  },

  heroBadges: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(1.5),
    marginTop: theme.spacing(2),
  },

  editButton: {
    background: '#fff',
    color: COLORS.primary,
    borderRadius: 12,
    padding: '12px 28px',
    fontWeight: 700,
    textTransform: 'none',

    '&:hover': {
      background: '#F7F3FF',
    },
  },

  section: {
    border: `1px solid ${COLORS.border}`,
    borderRadius: '16 !important',
    padding: theme.spacing(3),
    height: '100%',
    boxShadow: 'none !important',
    background: '#fff',
    boxSizing: 'border-box'
  },

  sectionHeader: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: theme.spacing(3),
  },

  sectionIcon: {
    width: 34,
    height: 34,
    borderRadius: '50%',
    background: theme.palette.primary.main || COLORS.primary,
    color: '#fff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: theme.spacing(1.5),
  },

  sectionTitle: {
    fontWeight: 800,
    color: COLORS.dark,
  },

  fieldRow: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: theme.spacing(2),
  },

  fieldIcon: {
    color: COLORS.dark,
    marginRight: theme.spacing(1.5),
    fontSize: 20,
  },

  fieldLabel: {
    width: 120,
    fontWeight: 700,
    color: COLORS.dark,
  },

  fieldValue: {
    color: COLORS.dark,
    fontWeight: 500,
  },

  statusBadge: {
    display: 'inline-flex',
    alignItems: 'center',
    borderRadius: 10,
    padding: '10px 16px',
    fontWeight: 700,
  },

  tag: {
    margin: theme.spacing(0.6),
    borderRadius: 20,
    fontWeight: 700,
    height: 34,
  },

  statCard: {
    border: `1px solid ${COLORS.border}`,
    borderRadius: 12,
    padding: theme.spacing(2),
    textAlign: 'center',
    height: '100%',
  },

  statIcon: {
    fontSize: 34,
    marginBottom: theme.spacing(1),
  },

  statValue: {
    fontWeight: 800,
    color: COLORS.dark,
  },

  statLabel: {
    color: COLORS.dark,
    fontSize: 13,
  },

  viewActivityButton: {
    marginTop: theme.spacing(2),
    border: `1px solid ${COLORS.border}`,
    borderRadius: 8,
    color: COLORS.secondary,
    fontWeight: 700,
    textTransform: 'none',
    background: '#fff',

    '&:hover': {
      background: COLORS.redBg,
    },
  },

  bioText: {
    color: COLORS.dark,
    lineHeight: 1.6,
    fontWeight: 500,
  },

  IdeaGrid: {
    display: "grid",
    marginTop: "32px",
    marginBottom: "60px",
    gridTemplateColumns: "repeat(2,minmax(128px,1fr))",
    gridGap: '8px',
    alignItems: "center",
    justifyItems: "center",
    '@media (min-width:480px)': { 
        gridTemplateColumns: "repeat(3,minmax(144px,1fr))",
    },
    '@media (min-width:1024px)': { 
        gridTemplateColumns: "repeat(4,minmax(238px,1fr))",
    },
  },


})
}
);